import types from "../types";

const initialState = {
  basicData: null,
  advertiserStats: {},
  globalMetrics: null,
  activityReport: null,
  advertisers: {},
  loading: false,
  error: null,
};

export const ownerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_OWNER_BASIC_DATA:
      return {
        ...state,
        basicData: action.payload,
        loading: false,
        error: null,
      };

    case types.GET_ADVERTISER_STATS:
      return {
        ...state,
        advertiserStats: {
          ...state.advertiserStats,
          [action.payload.advertiserID]: action.payload.data,
        },
        loading: false,
        error: null,
      };

    case types.GET_GLOBAL_METRICS:
      return {
        ...state,
        globalMetrics: action.payload,
        loading: false,
        error: null,
      };

    case types.UPDATE_ADVERTISER:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case types.GET_ADVERTISER_ACTIVITY_REPORT:
      return {
        ...state,
        activityReport: action.payload,
        loading: false,
        error: null,
      };

    case types.GET_ADVERTISERS:
      return {
        ...state,
        advertisers: action.payload,
        loading: false,
        error: null,
      };

    case types.GET_NEXT_ADVERTISERS:
      return {
        ...state,
        advertisers: {
          ...state.advertisers,
          ...action.payload,
        },
        loading: false,
        error: null,
      };

    case types.GLOBAL_RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default ownerReducer;
